import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import logo from '../../assets/sk-tt-logo.png'; // Imported logo
import './Navbar.css';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          
          {/* Logo Section */}
          <div className="navbar-logo">
            <img src={logo} alt="SK College" className="navbar-logo-img" />
            <h2 className="navbar-logo-text">S.K.T.T. COLLEGE, MANAKLAO</h2>
          </div>

          {/* Desktop Menu */}
          <ul className="nav-menu desktop-menu">
            <li>
              <NavLink to="/" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Home</NavLink>
            </li>
            <li>
              <NavLink to="/about" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>About</NavLink>
            </li>
            <li>
              <NavLink to="/gallery" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Gallery</NavLink>
            </li>
            <li>
              <NavLink to="/achievements" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Achievements</NavLink>
            </li>
            <li>
              <NavLink to="/contact" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Contact</NavLink>
            </li>
            {/* Admission Button */}
            <li>
              <NavLink to="/admission-form" className={({ isActive }) => isActive ? 'nav-link nav-admission active' : 'nav-link nav-admission'}>
                ADMISSION
              </NavLink>
            </li>
          </ul>

          {/* Mobile Menu Icon */}
          <div className="mobile-menu-icon" onClick={() => setMenuOpen(true)}>
            <FaBars />
          </div>
        </div>
      </nav>

      {/* Mobile Sidebar */}
      <div className={`mobile-sidebar ${menuOpen ? 'open' : ''}`}>
        <FaTimes className="close-icon" onClick={() => setMenuOpen(false)} />

        <ul className="sidebar-menu">
          <li>
            <NavLink to="/" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? 'active' : ''}>Home</NavLink>
          </li>
          <li>
            <NavLink to="/about" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? 'active' : ''}>About</NavLink>
          </li>
          <li>
            <NavLink to="/courses" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? 'active' : ''}>Course</NavLink>
          </li>
          <li>
            <NavLink to="/gallery" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? 'active' : ''}>Gallery</NavLink>
          </li>
          <li>
            <NavLink to="/achievements" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? 'active' : ''}>Achievements</NavLink>
          </li>
          <li>
            <NavLink to="/video-gallery" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? 'active' : ''}>Video Gallery</NavLink>
          </li>
          <li>
            <NavLink to="/news" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? 'active' : ''}>News</NavLink>
          </li>
          <li>
            <NavLink to="/contact" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? 'active' : ''}>Contact</NavLink>
          </li>
          <li>
            <NavLink to="/admission-form" onClick={() => setMenuOpen(false)} className={({ isActive }) => isActive ? 'sidebar-admission active' : 'sidebar-admission'}>
              ADMISSION
            </NavLink>
          </li>
        </ul>
      </div>
    </>
  );
}

export default Navbar;